module.exports = __webpack_public_path__ + "img/05-images-pc.3b709450.png";